import { Application } from '@mvecom/common/enums/Application.js';
import { splitPath } from '@mvecom/common/utils/splitPath.js';

export function getAppName(): Application | undefined {
  return splitPath(globalThis.location.pathname)[2] as unknown as Application;
}
